/**
 * @ngdoc service
 * @name app.pollsService
 * @description
 * # pollsService
 * Service to talk with backend api.
 * @requires app.apiService
 * @requires constants:config
 **/

/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import angular from 'angular';

/*---------------------------------------------------------*\
 * pollsService
\*---------------------------------------------------------*/
/* @ngInject */
function pollsService(apiService, config) {
  /**
   * @ngdoc
   * @name app.pollsService#getQuestion
   * @methodOf app.pollsService
   * @example
   * ``` js
   * pollsService.getQuestion('LI);
   * ```
   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
   * 'New Jersey' => 'NJ', max of three characters.
   * @description
   * Service to talk with backend api. It calls the apiService.wrap function,
   * passing the string formed from relative base Url, the '/polls/question/'
   * string, and the region passed in.
   * @returns {httpPromise} Promise that will resolve with the questionf or poll.
   **/
  this.getQuestion = (regionCode) => {
    return apiService.wrap(config.relBaseUrlAPi + '/polls/question/' + regionCode, {}, 'polls.getQuestion');
  };

  /**
   * @ngdoc
   * @name app.pollsService#postVote
   * @methodOf app.pollsService
   * @example
   * ``` js
   * pollsService.postVote('id1', 1);
   * ```
   * @param {string} pollId passes the id for current poll.
   * @param {number} choice passes the current selection.
   * @description
   * Service to talk with backend api. It calls the apiService.wrapPost function,
   * passing the string formed from relative base Url, the '/polls/vote' string,
   * the pollId, and choice passed in.
   * @returns {httpPromise} Promise that will resolve with the question or poll.
   **/
  this.postVote = (pollId, choice) => {
    return apiService.wrapPost(config.relBaseUrlAPi + '/polls/vote', {
      pollId,
      choice: choice.toString()
    }, {}, 'polls.postVote');
  };

  /**
   * @ngdoc
   * @name app.pollsService#getResults
   * @methodOf app.pollsService
   * @example
   * ``` js
   * pollsService.getResults('id1');
   * ```
   * @param {string} pollId passes the id for current poll.
   * @description
   * Service to talk with backend api. It calls the apiService.wrapPost function,
   * passing the string formed from relative base Url, the '/polls/results/' string,
   * and the passed in pollId.
   * @returns {httpPromise} Promise that will resolve with the poll results object.
   **/
  this.getResults = (pollId) => {
    return apiService.wrap(config.relBaseUrlAPi + '/polls/results/' + pollId, {}, 'polls.getResults');
  };
}

pollsService.$inject = [
  'apiService',
  'config'
];

const api = angular
  .module('pollsService', [])
  .service('pollsService', pollsService);

export default api;



/** WEBPACK FOOTER **
 ** ./client/app/services/apis/polls.js
 **/